import PropTypes from 'prop-types';
import React from 'react';

import Theme from 'styles/theme';

const FilterToggleBadge = ({ children }) => {
  return (
    <div className="FilterToggleBadge">
      ({children})
      <style jsx>{`
        .FilterToggleBadge {
          margin-left: ${Theme.get('spacing') / 2.5}px;
          font-size: ${Theme.get('font-size-small-px')};
          color: ${Theme.get('colors-black')};
        }
      `}</style>
    </div>
  );
};

FilterToggleBadge.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

FilterToggleBadge.defaultProps = {
  children: null,
};

export default FilterToggleBadge;
